import { mockData as meetingEventsData } from '@web/lib/demo/data/meetingEvents';
import { mockData as users } from '@web/lib/demo/data/users';
import { filterData, getUsers } from '@web/lib/demo/utils';
var getOrgUnitTitle = function (userId) {
    var _a, _b, _c, _d;
    var user = users.find(function (u) { return u.id === userId; });
    return (_d = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.userOrgUnits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.orgUnit) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : null;
};
export var meetAdvancedSearch = function (input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var orgUnitUserIds = input.orgUnitId
        ? getUsers({ orgUnitId: input.orgUnitId }).map(function (user) { return user.id; })
        : null;
    var meetings = filterData(meetingEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: (_a = input.userId) !== null && _a !== void 0 ? _a : 0,
            operator: 'eq',
            isSkip: !input.userId
        },
        {
            key: 'userId',
            value: orgUnitUserIds !== null && orgUnitUserIds !== void 0 ? orgUnitUserIds : [],
            operator: 'in',
            isSkip: !input.orgUnitId
        },
        {
            key: 'title',
            value: (_b = input.title) !== null && _b !== void 0 ? _b : '',
            operator: 'contains',
            isSkip: !input.title
        },
        {
            key: 'isRecurring',
            value: (_c = input.isRecurring) !== null && _c !== void 0 ? _c : false,
            operator: 'eq',
            isSkip: !input.isRecurring
        },
        {
            key: 'isScheduled',
            value: (_d = input.isScheduled) !== null && _d !== void 0 ? _d : false,
            operator: 'eq',
            isSkip: !input.isScheduled
        },
        {
            key: 'durationSeconds',
            value: (_e = input.durationSecondsFrom) !== null && _e !== void 0 ? _e : 0,
            operator: 'gt',
            isSkip: !input.durationSecondsFrom
        },
        {
            key: 'durationSeconds',
            value: (_f = input.durationSecondsTo) !== null && _f !== void 0 ? _f : 0,
            operator: 'lt',
            isSkip: !input.durationSecondsTo
        },
        {
            key: 'overrunDurationSeconds',
            value: (_g = input.overrunDurationSecondsFrom) !== null && _g !== void 0 ? _g : 0,
            operator: 'gt',
            isSkip: !input.overrunDurationSecondsFrom
        },
        {
            key: 'overrunDurationSeconds',
            value: (_h = input.overrunDurationSecondsTo) !== null && _h !== void 0 ? _h : 0,
            operator: 'lt',
            isSkip: !input.overrunDurationSecondsTo
        },
        {
            key: 'isExternalParticipants',
            value: (_j = input.isExternalParticipants) !== null && _j !== void 0 ? _j : false,
            operator: 'eq',
            isSkip: !input.isExternalParticipants
        },
        {
            key: 'withActivitiesAction',
            value: (_k = input.withActivitiesAction) !== null && _k !== void 0 ? _k : '',
            operator: 'eq',
            isSkip: !input.withActivitiesAction
        }
    ]).map(function (meetingEvent, index) {
        var meeting = meetingEvent.meeting;
        var presentGuests = meeting.meetingGuests.filter(function (guest) { return guest.isPresentAtMeeting; });
        var timingDeltaSeconds = meeting.overrunDurationSeconds && meeting.overrunDurationSeconds !== 0
            ? meeting.overrunDurationSeconds
            : // Demo variety: overran / finished early / on time
                [720, -600, 0, 300, -300, 600, 180, 0, -480, 0][index % 10];
        var organizerId = meeting.organizerId;
        var organizerUser = organizerId
            ? users.find(function (user) { return user.id === organizerId; })
            : null;
        return {
            id: meeting.id,
            title: meeting.title,
            date: meeting.date,
            durationSeconds: meeting.durationSeconds,
            timingDeltaSeconds: timingDeltaSeconds,
            isScheduled: meeting.calendarId != null,
            isRecurring: Boolean(meeting.calendarId && index % 3 === 0),
            externalGuestsCount: presentGuests.filter(function (guest) { return guest.isExternal; })
                .length,
            organizer: organizerUser
                ? {
                    id: organizerUser.id,
                    name: organizerUser.name,
                    email: organizerUser.email,
                    orgUnitTitle: getOrgUnitTitle(organizerUser.id)
                }
                : null,
            meetingGuests: presentGuests.map(function (guest) {
                var _a, _b, _c;
                var user = users.find(function (u) { return u.id === guest.userId; });
                return {
                    isExternal: guest.isExternal,
                    user: {
                        id: guest.userId,
                        name: (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : 'demo',
                        email: (_b = user === null || user === void 0 ? void 0 : user.email) !== null && _b !== void 0 ? _b : 'demo@demo.com',
                        avatar: (_c = user === null || user === void 0 ? void 0 : user.avatar) !== null && _c !== void 0 ? _c : null,
                        orgUnitTitle: guest.isExternal
                            ? null
                            : getOrgUnitTitle(guest.userId)
                    }
                };
            })
        };
    });
    var meetingsEventsData = input.offset && input.limit
        ? meetings.slice(input.offset, input.offset + input.limit)
        : meetings;
    return {
        data: meetingsEventsData,
        total: meetings.length
    };
};
